import { computed } from "mobx";
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from "react-router-dom";
import { useLeadStore, useLeaseCompStore } from '../..';
import useCircleWithRadius from '../../hooks/useCircleWithRadius';
import useCircleWithRadiusOnMap from "../../hooks/useCircleWithRadiusOnMap";
import useLeaseCompsWithFocusArea from "../../hooks/useLeaseCompsWithFocusArea";
import useLeaseCompsWithGlobalFilters from "../../hooks/useLeaseCompsWithGlobalFilters";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import { formatNumber } from '../../utils/utils';
import LeaseCompsGrid from "../leaseComps/LeaseCompsGrid";
import RadiusDropdown from "../RadiusDropdown";

function LeadDetailsLeaseCompsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const leadStore = useLeadStore();
    const leaseCompStore = useLeaseCompStore();
    const lead = useMemo(() => computed(() => leadStore.leads.find(l => l.id.toString() === id)!), [id]).get();
    const [radius, setRadius] = useState(5);
    const circle = useCircleWithRadius(lead.centerPoint, radius)!;
    useCircleWithRadiusOnMap(lead.centerPoint, radius, visible, "LeadDetailsLeaseCompsTab");
    const leaseComps = useLeaseCompsWithFocusArea(useLeaseCompsWithGlobalFilters(
        useMemo(() => computed(() => leaseCompStore.leaseComps.filter(lc => circle.isPointInside(lc.centerPoint))), [circle]).get()
    ));

    useEffect(() => setEntityCount(leaseComps.length), [leaseComps]);

    if (!visible)
        return null;

    return (
        <LeaseCompsGrid
            leaseComps={leaseComps}
            additionalHeaders={[{
                titleStrings: ["DISTANCE"],
                getValue: item => circle!.getDistanceFromCenter(item.centerPoint),
                getLabel: item => {
                    const distance = circle!.getDistanceFromCenter(item.centerPoint);
                    return distance ? formatNumber(distance) : "";
                }
            }]}
            radiusDropdown={<RadiusDropdown value={radius} onChange={setRadius} />}
        />
    );
}

export default observer(LeadDetailsLeaseCompsTab);
